import { render, staticRenderFns } from "./IncapacidadesTipos.vue?vue&type=template&id=4f9904f8&scoped=true"
import script from "./IncapacidadesTipos.vue?vue&type=script&lang=js"
export * from "./IncapacidadesTipos.vue?vue&type=script&lang=js"
import style0 from "./IncapacidadesTipos.vue?vue&type=style&index=0&id=4f9904f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9904f8",
  null
  
)

export default component.exports